import { render } from "./UserManagmentBtnCellRenderer.vue?vue&type=template&id=23c3a795&scoped=true"
import script from "./UserManagmentBtnCellRenderer.vue?vue&type=script&lang=js"
export * from "./UserManagmentBtnCellRenderer.vue?vue&type=script&lang=js"

import "./UserManagmentBtnCellRenderer.vue?vue&type=style&index=0&id=23c3a795&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c3a795"]])

export default __exports__